<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <div>
            <v-btn
              class="mx-2 float-right"
              fab
              dark
              small
              color="blue-grey"
              :to="{ name: 'transactions' }"
            >
              <v-icon dark>mdi-format-list-bulleted-square</v-icon>
            </v-btn>
          </div>
          <div style="clear: both"></div>
          <template>
            <!--                :disable-pagination ="paginat"-->
            <!--            <v-data-table-->
            <!--              :headers="headers"-->
            <!--              :items="desserts"-->
            <!--              :items-per-page="5"-->
            <!--              hide-default-footer-->
            <!--            >-->
            <!--              <template v-slot:item.type="{ item }">-->
            <!--                <v-chip-->
            <!--                  :color="getColor(item.type)"-->
            <!--                  dark-->
            <!--                  outlined-->
            <!--                  label-->
            <!--                  style="width: 125px"-->
            <!--                >-->
            <!--                  <v-icon left size="16">{{ getIcon(item.type) }}</v-icon>-->
            <!--                  {{ item.type }}-->
            <!--                </v-chip>-->
            <!--              </template>-->
            <!--              <template v-slot:item.value="{ item }">-->
            <!--                <span :style="getColorMount(item.value)">-->
            <!--                  {{ new Intl.NumberFormat("de-DE").format(item.value) }}-->
            <!--                </span>-->
            <!--              </template>-->
            <!--            </v-data-table>-->

            <v-data-table
              :headers="headers"
              :items="getAllETransactions"
              :items-per-page="5"
              single-select
              item-key="name"
              style="cursor: pointer"
              hide-default-footer
            >
              <template v-slot:item.transactionType="{ item }">
                <v-chip
                  :color="getColor(item.transactionType)"
                  dark
                  outlined
                  label
                  style="width: 125px; cursor: pointer"
                >
                  <v-icon left size="16">{{
                    getIcon(item.transactionType)
                  }}</v-icon>
                  {{ item.transactionType }}
                </v-chip>
              </template>
              <template v-slot:item.transactionAmount="{ item }">
                <span :style="getColorMount(item.transactionAmount)">
                  {{
                    new Intl.NumberFormat("de-DE").format(
                      item.transactionAmount
                    )
                  }}
                  Akz
                </span>
              </template>

              <template v-slot:item.dateTransaction="{ item }">
                <span :style="getColorMount(item.dateTransaction)">
                  {{ formatData(item.dateTransaction) }}
                </span>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";

export default {
  name: "ResumeTransactions",
  data() {
    return {
      headers: [
        {
          text: "REFERÊNCIA",
          align: "start",
          sortable: false,
          value: "transactionDescription"
        },
        { text: "TIPO", value: "transactionType" },
        { text: "MONTANTE", value: "transactionAmount" },
        { text: "PRODUTO", value: "productName" },
        { text: "DATA", value: "dateTransaction" }
      ]
    };
  },
  methods: {
    goToListTransfer() {
      this.$router.push("/overview/history");
    },
    getColor(type) {
      if (type === "Entrada") return "green";
      else if (type === "Saída") return "red";
      else return "orange";
    },
    getIcon(type) {
      if (type === "Entrada") return "mdi-arrow-up";
      else if (type === "Saída") return "mdi-arrow-down";
      else return "mdi-swap-horizontal";
    },
    getColorMount() {
      return "color:#1976d2c4";
    },
    formatData(convertData) {
      let format = new Date(convertData);
      return format.toISOString().split("T")[0];
    }
  },
  computed: {
    ...mapHelperEnterprise
  }
  // mounted() {
  //     this.getUserProfile()
  // }
};
</script>

<style scoped></style>
